<template>
    <section class="gallery">
      <div
        :class="['swiper', 'gallery__slides', `swiper-container-${galleryData.id}`]"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(slide, j) in galleryData.gallery"
            :key="`slide-${j}`"
          >
            <img
              class="gallery__slide-image"
              :alt="`${galleryData.key}-${slide}`"
              :src="carImageGallery(galleryData.key, slide)"
              @click="$emit('openGallery', galleryData, slide)"
            />
          </div>
        </div>
        <div
          :class="['swiper-button-prev', `swiper-button-prev-${galleryData.id}`]"
        ></div>
        <div
          :class="['swiper-button-next', `swiper-button-next-${galleryData.id}`]"
        ></div>
      </div>
    </section>
</template>

<script>
import Swiper from "swiper";
import Mixin from "@/common/mixin";

export default {
  name: "gallery",
  mixins: [Mixin],
  props: ["galleryData"],
  data() {
    return {
      swiper: null,
    };
  },
  mounted() {
    this.initSwiper();
  },
  computed: {
    carImageGallery: () => (name, num) => {
      try {
        return require(`../../../images/cars/${name}/gallery/${num}.webp`);
      } catch {
        try {
          return require(`../../../images/cars/${name}/gallery/${num}.png`);
        } catch {
          return require(`../../../images/cars/${name}/gallery/${num}.jpg`);
        }
      }
    },
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.swiper-container-${this.galleryData.id}`, {
        slidesPerView: 3,
        spaceBetween: 5,
        freeMode: true,
        simulateTouch: true,
        autoplay: false,
        updateOnImagesReady: true,
        observer: true,
        observeParents: true,
        breakpointsInverse: true, 
        navigation: {
          nextEl: `.swiper-button-next-${this.galleryData.id}`,
          prevEl: `.swiper-button-prev-${this.galleryData.id}`,
        },
        breakpoints: {
          320: {
            slidesPerView: 3,
            spaceBetween: 5
          },
          640: {
            slidesPerView: 4,
            spaceBetween: 15
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.gallery {
  display: flex;
  align-items: center;
  width: 40em;

  &__slides {
    position: relative;
    margin: 0 2.1em;
    overflow: hidden;
    height: 5.8em;
  }

  &__slide-image {
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .swiper-slide {
    width: calc((100% - 45px) / 4) !important;
    height: 100%;
  }
}

@media (max-width: 640px) {
  .gallery {
    margin-top: 3em;
    width: calcFontSize(300, 600, 340, 640);

    .swiper-slide {
      width: calc((100% - 10px) / 3);
    }
  }
}
</style>
